import { booleanAttribute, Directive, input } from '@angular/core';

@Directive({
  selector: '[cuePreventContextMenu]',
  host: {
    '(contextmenu)': 'onRightClick($event)',
  },
})
export class DisableRightClickDirective {
  cuePreventContextMenu = input<boolean, boolean | 'true' | 'false'>(false, {
    transform: booleanAttribute,
  });

  onRightClick(event: MouseEvent) {
    if (this.cuePreventContextMenu()) {
      event.preventDefault();
    }
  }
}
